<template>
	<div class="home">
		<div class="home_con_1">
			<img class="home_con_1_img" :src="bannerImage" />
			<h1>{{ $t('about.about') }}</h1>
		</div>
		<div class="home_con_2">
			<div class="text-content-left" >
				<h3 style="text-align: left;letter-spacing: 13px">{{ $t('about.title') }}</h3>
				<h3 style="text-align: left;">2024</h3>
				<!-- <img :src="require('../assets/about/go-'+$t('theme.title')+'.png')" alt=""> -->
				<img :src="require('../assets/about/go-zh.png')" alt="">
			</div>
			<div class="text-content-right">
				<h3 style="font-size: 40px; text-align: left; margin-bottom: 25px">{{ $t('about.about_vtimes_0') }}</h3>
				<p style="font-size: 18px; text-align: left">{{ $t('about.about_vtimes') }}</p>
			</div>
		</div>
		<div class="home_con_2">
			<img src="../assets/about/about_1.jpg" style="width: 95%; height: auto; position: relative; left: 2.5%" />
		</div>
		<div class="home_con_3">
			<div class="about3_item">
				<div class="about3-content-left">
					<p style="font-size: 32px; font-weight: 500">{{ $t('about.about_3_t1') }}</p>
					<p style="font-size: 28px; color: #333">{{ $t('about.about_3_c1') }}</p>
				</div>
				<img src="../assets/about/about_2_1.jpg" style="width: 50%; height: auto" />
			</div>
			<div class="about3_item">
				<div class="about3-content-left">
					<p style="font-size: 32px; font-weight: 500">{{ $t('about.about_3_t2') }}</p>
					<p style="font-size: 28px; color: #333">{{ $t('about.about_3_c2') }}</p>
				</div>
				<img src="../assets/about/about_2_2.jpg" style="width: 50%; height: auto" />
			</div>
			<div class="about3_item">
				<div class="about3-content-left">
					<p style="font-size: 32px; font-weight: 500">{{ $t('about.about_3_t3') }}</p>
					<p style="font-size: 28px; color: #333">{{ $t('about.about_3_c3') }}</p>
				</div>
				<img src="../assets/about/about_2_3.jpg" style="width: 50%; height: auto" />
			</div>
		</div>
		<div class="home_con_6">
			<div style="width: 50%"></div>
			<div class="about6-content-right">
				<h5>{{ $t('about.title6') }}</h5>
				<p>{{ $t('about.description6') }}</p>
				<p>{{ $t('about.description6_2') }}</p>
			</div>
		</div>
		<!-- 		<div class="home_con_4">
			<h2>{{ $t('about.title4') }}</h2>
		</div> -->
		<div class="home_con_5">
			<h2 style="margin-bottom: 35px">{{ $t('about.title5') }}</h2>
			<img src="../assets/about/about_4.jpg" />
		</div>
	</div>
</template>

<script>
import { bannerApi, baseImgUrl } from '../netTool/api';

export default {
	name: 'Home',
	components: {},
	data() {
		return {
			bannerImage: ''
		};
	},
	async mounted() {
		try {
			const navId = 2;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		} catch (error) {}
	}
};
</script>

<style scoped>
.home {
	width: 100%;
	overflow: hidden;
	text-align: center;
	align-items: center;
	background-color: #fff;
}

.home_con_1 {
	position: relative;
}

h1 {
	font-size: 60px;
	color: #fff;
	font-weight: bold;
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
	position: absolute;
	bottom: max(10%, 14px);
	left: max(8%, 30px);
}

h2 {
	font-size: 2.5rem;
	color: #333;
	margin-bottom: 10px;
}

h3 {
	/* color: #009dda; */
	color: var(--active-nav-color);
}

.home_con_1_img {
	width: 100%;
	height: auto;
	background-repeat: no-repeat;
	background-position: center;
}

.home_con_2 {
	background-color: #fff;
	position: relative;
	display: flex;
	text-align: center;
	align-items: center;
}

.text-content-left {
	width: 45%;
	height: 100%;
	margin-top: 35px;
	padding-bottom: 65px;
	padding-left: 15%;
	padding-right: 0%;
	text-align: center;
	align-items: center;
	justify-content: center;
}

.text-content-left h3 {
	font-family: YouSheBiaoTiHei;
	font-size: 100px;
	font-weight: normal;
	/* line-height: 0.85; */
}

.text-content-right {
	width: 55%;
	padding: 30px 10%;
	align-items: center;
	text-align: center;
	line-height: 1.2;
}

.home_con_3 {
	margin: 50px 0;
}

.about3_item {
	width: 65%;
	background-color: #ebebeb;
	margin: 40px auto;
	border-radius: 8px;
	display: flex;
	align-items: center;
	text-align:left;
	justify-content: space-between;
}

@media screen and (min-width: 1200px) {
	.home_con_3 {
		display: flex;
		gap: 20px;
	}
	
	.about3_item {
		margin: 0;
	}
}

.about3-content-left {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	height: 100%;
	width: 50%;
	padding-left: 5%;
	padding-right: 5%;
	line-height: 1.8;
}

.about3-content-left p:first-child {
	font-size: 32px;
	font-weight: 500;
}

.about3-content-left p:last-child {
	font-size: 28px;
	color: #333;
}

.home_con_5 {
	padding: 50px;
	background-color: #fff;
}

.home_con_6 {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	aspect-ratio: 1920/693;
	background-image: url('../assets/about/about_3.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center left;
}

.about6-content-right {
	flex: 1;
	max-width: 500px;
	text-align: left;
}

.about6-content-right h5 {
	font-size: 2.5rem;
	color: var(--active-nav-color);
	margin-bottom: 20px;
}

.about6-content-right p {
	font-size: 1rem;
	color: #666;
	line-height: 1.6;
	margin-bottom: 30px;
}

/* 适配小于1200px的屏幕 */
@media (max-width: 1199px) {
	.text-content-left {
		padding-left: 10%;
	}

	.text-content-left h3 {
		font-size: 64px;
	}

	.about3_item {
		width: 85%;
	}
}

/* 适配小于768px的屏幕（平板） */
@media (max-width: 768px) {
	h1 {
		font-size: 72px;
	}

	.home_con_2 {
		flex-direction: column;
	}

	.home_con_2>img {
		left: 0 !important;
	}

	.text-content-left {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.text-content-right {
		width: 100%;
	}

	.text-content-left {
		padding: 30px 10%;
	}

	.text-content-left h3 {
		font-size: 48px;
		text-align: center !important;
	}

	.about3_item {
		flex-direction: column;
		width: 90%;
	}

	.about3-content-left,
	.about3_item img {
		width: 100% !important;
	}

	.about3-content-left {
		padding: 20px 5%;
		align-items: center;
		text-align: center;
	}

	.about3-content-left p:first-child {
		font-size: 28px;
	}

	.about3-content-left p:last-child {
		font-size: 24px;
	}

	.home_con_6 {
		flex-direction: column;
		aspect-ratio: auto;
		padding: 50px 0;
	}

	.home_con_6 > div:first-child {
		display: none;
	}

	.about6-content-right {
		max-width: 80%;
		padding: 0 10%;
	}
}

/* 适配小于468px的屏幕（手机） */
@media (max-width: 468px) {
	h1 {
		font-size: 36px;
	}

	h2 {
		font-size: 1.8rem;
	}

	.text-content-left h3 {
		font-size: 36px;
	}

	.text-content-right h3 {
		font-size: 28px;
	}

	.about3_item {
		width: 95%;
	}

	.about3-content-left p:first-child {
		font-size: 24px;
	}

	.about3-content-left p:last-child {
		font-size: 20px;
	}

	.about6-content-right h5 {
		font-size: 1.8rem;
	}

	.home_con_5 {
		padding: 30px 15px;
	}
}
</style>
